define("shared/utils/constants/keys", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const KEYS = Object.freeze({
    ENTER: {
      code: 'Enter',
      key: 'Enter'
    },
    ESCAPE: {
      code: 'Escape',
      key: 'Escape'
    },
    SPACE: {
      code: 'Space',
      key: ' '
    },
    COMMA: {
      code: 'Comma',
      key: ','
    }
  });
  var _default = _exports.default = KEYS;
});